import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import href from '#utilities/js/ea/href.js'
import globals from '../../ea/globals.js'
import rte from '../rte.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import closest from "@mailobj-browser/front/js/selectors/closest.js"

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button
  ) => {
		const form = closest('form', button)
    const rte = one('iframe[data-rte]', form)

	if (rte && rte.id) {
      const url = href('auth/colorpanel', {
	    'id_txt': 'rte',
	    'id_bkg': 'rte',
	    'table': '12x19',
	    'preview': 1,
	    'cancel': 1,
	    'color': globals.ea_rte_hilitecolor
	  });
		
		globals.ea_rte_update_editor(globals.ea_rte_current);
		globals.ea_rte_context_menu(button, null, rte.id, 'hilitecolor', 'rte_opt_cp', url);
	}

  }
})

export const highlight = (
  button,
  modifier,
  text
) => {
	return closest('font[style*="background-color:"]', text)
}

export default button => {
  onClick.listen(button)
  rte(button, object(null, { highlight }))
}
